<template>
  <div class="tag-search-wrapper">
    <div class="tag-search-header">
      <div class="title">#태그검색
        <div class="close-button" @click="close">
          <CloseButtonIcon/>
        </div>
      </div>
      <div class="tab">
        <div :class="currentTab === 'broadCast' ? 'tab-item selected' : 'tab-item'"
             @click.prevent="()=>selectTab('broadCast')">
          <div>
            방송
          </div>
        </div>
        <div :class="currentTab === 'movie' ? 'tab-item selected' : 'tab-item'" @click.prevent="()=>selectTab('movie')">
          <div>
            영화
          </div>
        </div>
      </div>
    </div>
    <div class="tag-list-wrapper">
      <div class="category-list" v-if="currentTab === 'broadCast'"  ref="tagList">
        <ul>
          <li v-for="(tagGroup, index) in broadCastTagList" :key="tagGroup.title + index">
            <div class="tag-group-item">
              <div class="tag-title">{{tagGroup.title}}</div>
            </div>
            <div class="tag-list" v-for="(subGroup, index) in tagGroup.tagsubgrouplist"
                 :key="tagGroup.title+'_tag'+index">
              <div :class="subGroup.title ? 'tag-sub-icon-title' : 'tag-sub-icon-title-none'">
                <img v-if="subGroup.iconimage" :src="'https://'+subGroup.iconimage" />
                <div class="sub-group-title">{{subGroup.title}}</div>
              </div>
              <span v-for="(tag, index) in subGroup.list"
                    :key="tag.text+index"
                    :class="tag.taggroup.indexOf('select') > -1 ? 'tag-item selected' : 'tag-item'"
                    @click.stop="()=>selectTag(tag)"
              >{{tag.text}}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="category-list" v-if="currentTab === 'movie'"  ref="tagList">
        <ul>
          <li v-for="(tagGroup, index) in movieTagList" :key="tagGroup.title + index">
            <div class="tag-group-item">
              <div class="tag-title" v-if="tagGroup.title !== ''">{{tagGroup.title}}</div>
            </div>
            <div class="tag-list" v-for="(subGroup, index) in tagGroup.tagsubgrouplist"
                 :key="tagGroup.title+'_tag'+index">
              <div class="sub-group-title">{{subGroup.title}}</div>
              <span v-for="(tag, index) in subGroup.list"
                    :key="tag.text+index"
                    :class="tag.taggroup.indexOf('select') > -1 ? 'tag-item selected' : 'tag-item'"
                    @click.stop="()=>selectTag(tag)"
              >{{tag.text}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
<!--    <div class="dummy-place" v-if="selectedTagList[currentTab].length > 0"></div>-->
    <div class="bottom-menu" v-if="selectedTagList[currentTab].length > 0">
      <div class="reset" @click.prevent="resetSelectedTag">선택초기화</div>
      <div class="search" @click.prevent="searchSelectedTag">검색</div>
    </div>
  </div>

</template>

<script>
import { SearchService } from '@/common/api/api.service'
import { TAGS_BROAD_CAST, TAGS_MOVIE } from '@/common/constant'
import { get } from 'lodash'
import { EventBus } from '@/components/eventbus/EventBus'
import CloseButtonIcon from '@/assets/svg/common/ic_gnb_close_w.svg'
import { enableBodyScroll, disableBodyScroll } from '@/common/util/ui.utils'

export default {
  name: 'TagSearchView',
  components: {
    CloseButtonIcon
  },
  props: ['prevTagList', 'prevTabType'],
  data () {
    return {
      currentTab: 'broadCast', // broadCast, movie
      broadCastTagList: [],
      movieTagList: [],
      selectedTagList: {
        broadCast: [],
        movie: []
      }
    }
  },
  methods: {
    selectTab (tabType) {
      this.currentTab = tabType
      window.scrollTo(0, 0)
    },
    close () {
      EventBus.$emit('hide-tag-search')
      enableBodyScroll()
    },
    _findAndSetTag (tagList) {
      tagList.forEach((tagGroup) => {
        tagGroup.tagsubgrouplist.forEach((subGroup) => {
          subGroup.list.forEach((tag) => {
            this.selectedTagList[this.prevTabType].forEach((selectedTag) => {
              if (selectedTag.value === tag.value) {
                tag.taggroup = tag.taggroup + ' select'
              }
            })
          })
        })
      })
    },
    setData (force = false) {
      const boardCast = SearchService.getTagList({ type: TAGS_BROAD_CAST })
      const movie = SearchService.getTagList({ type: TAGS_MOVIE })
      this.axios.all([boardCast, movie]).then(this.axios.spread((boardCastRes, movieRes) => {
        const tempBroadCastTagList = get(boardCastRes, ['data', 'taggrouptitlelist'], [])
        const tempMovieTagList = get(movieRes, ['data', 'taggrouptitlelist'], [])
        if (!force) {
          if (this.prevTagList && this.prevTabType) { // 기존 조회정보가 있을때
            this.currentTab = this.prevTabType
            this.selectedTagList[this.prevTabType] = this.prevTagList.map((tag) => {
              return {
                taggroup: tag.taggroup + ' select',
                text: tag.text.replace('#', ''),
                value: tag.value
              }
            })
            this._findAndSetTag(tempBroadCastTagList)
            this._findAndSetTag(tempMovieTagList)
          }
        }
        this.broadCastTagList = tempBroadCastTagList
        this.movieTagList = tempMovieTagList
      }))
    },
    selectTag (tag) {
      if (tag.taggroup.indexOf('select') > -1) {
        this.selectedTagList[this.currentTab] =
            this.selectedTagList[this.currentTab].filter((selectedTag) => selectedTag.value !== tag.value)
        tag.taggroup = tag.taggroup.replace(' select', '')
      } else {
        tag.taggroup = tag.taggroup + ' select'
        this.selectedTagList[this.currentTab].push(tag)
      }
    },
    resetSelectedTag () {
      this.selectedTagList[this.currentTab].map((selectedTag) => {
        selectedTag.taggroup = selectedTag.taggroup.replace(' select', '')
        return selectedTag
      })
      this.selectedTagList[this.currentTab] = []
      this.setData(true)
    },
    searchSelectedTag () {
      const tagList = this.selectedTagList[this.currentTab]
      const searchTags = tagList.map((tag) => {
        return {
          taggroup: tag.taggroup.replace(' select', ''),
          text: '#' + tag.text,
          value: tag.value
        }
      })
      window.scrollTo(0, 0)
      EventBus.$emit('search-by-tag', { searchTags, tabType: this.currentTab })
    }
  },
  mounted () {
    this.setData()
    enableBodyScroll()
  },
  watch: {
    currentTab (newVal) {
      this.$nextTick(() => {
        document.querySelector('.search-wrapper').scrollTo(0, 0)
      })
    }
  }
}
</script>

<style scoped>
  .category-list{
    height: 100%;
    padding-top: 80px;
    padding-bottom: 50px;
    overflow-y: scroll;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
  }

  .category-list li{
    padding: 0 5px;
    border-bottom: 1px solid #252525
  }

  .tag-search-wrapper {
    position: relative;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background-color: #1b1b1b;
    z-index: 4000
  }

  .tag-search-header {
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    color: #fff;
    background-color: #1b1b1b;
    z-index: 1500;
    border-bottom: 1px solid #3e3e3e;
  }

  .tag-search-header .title {
    position: relative;
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 40px;
    text-align: center
  }

  .tag-search-header .close-button {
    position: absolute;
    width: 36px;
    height: 36px;
    z-index: 100;
    right: 4px;
    top: 4px;
    padding-top: 6px;
    padding-right: 6px
  }

  .tag-search-header .tab {
    position: relative;
    width: 100%;
    height: 40px;
    box-sizing: border-box
  }

  .tag-search-header .tab .tab-item {
    width: 50%;
    height: 30px;
    float: left;
    position: relative;
    font-size: 14px;
    box-sizing: border-box;
    line-height: 40px;
    text-align: center;
  }

  .tag-search-header .tab .tab-item div{
    color: #a5a5a5;
  }

  .tag-search-header .tab .tab-item.selected div {
    position: relative;
    display: inline-block;
    height: 40px;
    margin: 0 auto;
    padding: 0 25px;
    font-weight: 700;
    color: #fff;
    border-bottom: 4px solid #1351f9;
  }

  .tag-group-item {
    width: 100%;
    padding: 20px 0 16px 5px;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 17px;
    color: #fff;
  }

  .tag-list-wrapper {
    z-index: 1000;
    position: relative;
    /*margin-top: 80px;*/
    width: 100%;
    height: 100%;
    background-color: #1b1b1b;
  }

  .tag-list{
    padding-bottom: 20px
  }

  .tag-sub-icon-title{
    padding: 5px 0 11px 0;
    line-height: 20px;
  }

  .tag-sub-icon-title img{
    display: inline-block;
    width: 20px;
    height: 20px;
    color: #fff;
  }

  .tag-sub-icon-title .sub-group-title{
    display: inline-block;
    padding-left: 4px;
    font-size: 14px;
    line-height: 20px;
    color: #fff;
  }

  .tag-item{
    display: inline-block;
    margin: 6px 4px;
    padding: 5px 20px;
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
    border-radius: 16px;
    background-color: #1b1b1b;
    border: 1px solid #a5a5a5;
  }

  .tag-item.selected{
    background-color: #1351f9;
    color: #fff;
    border: 1px solid #1351f9;
  }

  .bottom-menu {
    position: fixed;
    width: 100%;
    height: 50px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2000;
  }

  .bottom-menu div {
    position: relative;
    float: left;
    width: 50%;
    line-height: 50px;
    text-align: center;
    color: #fff;
    font-size: 15px;
  }

  .bottom-menu .reset {
    height: 100%;
    background-color: #161616;
  }

  .bottom-menu .search {
    height: 100%;
    background-color: #1351f9;
  }

  /*.dummy-place {*/
  /*  position: relative;*/
  /*  width: 100%;*/
  /*  height: 50px;*/
  /*}*/
</style>
